export default "__VITE_ASSET__DdywiGNP__"